import React, { Fragment } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainView from './views/main';

import { HasPermission } from 'Core/security';
import { useSelector } from 'react-redux';

const RoutesBehavior = ({ }) => {

	const user = useSelector(state => state.securityRedux.user);
	return (
		<Routes>
			{
				HasPermission(user, 'behavior', [214]) &&
				<Fragment>
					<Route path='/' element={<Navigate to="/app/behavior/main" />}></Route>
					<Route path='main' element={<MainView />} />
				</Fragment>
			}
			<Route path="*" element={<Navigate to="/app/error" />} />
		</Routes>
	);
}

export default RoutesBehavior
